import { render, staticRenderFns } from "./CourseBuilderQuizForm.vue?vue&type=template&id=a09ce84a&scoped=true&"
import script from "./CourseBuilderQuizForm.vue?vue&type=script&lang=js&"
export * from "./CourseBuilderQuizForm.vue?vue&type=script&lang=js&"
import style0 from "./CourseBuilderQuizForm.vue?vue&type=style&index=0&id=a09ce84a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a09ce84a",
  null
  
)

export default component.exports